module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-3.3fe3d72f.webp";